import React, { useEffect, useState } from 'react';
import { renderLatex } from '@/utils/math';

interface Props {
  text: string;
  className?: string;
}

export const MathText: React.FC<Props> = ({ text, className }) => {
  const [html, setHtml] = useState<string>();
  const [hasFailed, setHasFailed] = useState(false);

  useEffect(() => {
    let isActive = true;

    const render = async () => {
      const rendered = await renderLatex(text);

      if (!isActive) {
        return;
      }

      setHtml(rendered);
      setHasFailed(!rendered);
    };

    void render();

    return () => {
      isActive = false;
    };
  }, [text]);

  if (hasFailed) {
    return <span className={className}>{text}</span>;
  }

  return (
    <span
      className={`-my-0.5 overflow-x-auto overflow-y-hidden py-0.5 ${className ?? ''}`}
      dangerouslySetInnerHTML={html ? { __html: html } : undefined}
    />
  );
};
